import React from "react";
import useProductDetailPageAttrQuery from "../hooks/useProductDetailPageAttrQuery";
import { Box, HStack, List, ListItem, Text } from "@chakra-ui/react";
import { SpecificationHero } from "../styles";

const Specification = () => {
  const { data: result } = useProductDetailPageAttrQuery();
  const { specifications } = result!.data.attributes;

  return (
    <SpecificationHero>
      <List>
        {specifications?.map((specification, index) => (
          <ListItem key={index} bg={index % 2 === 0 ? "white50" : "white"}>
            <HStack px={4} pt={4} alignItems={"flex-start"}>
              <Box flex="1">
                <Text>{specification.title}</Text>
              </Box>

              <Box flex="2">
                <Text>{specification.content}</Text>
              </Box>
            </HStack>
          </ListItem>
        ))}
      </List>
    </SpecificationHero>
  );
};
export default Specification;
